import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { fetchVirtualOperatorMessagesRequest, fetchVirtualOperatorSettingsRequest } from '../../../../js/virtualOperator/actions';
import GlobalErrorPage from '../../../pages/GlobalErrorPage';
import Loading from '../../../../components/Loading';
import HelpButton from '../../../../components/HelpButton';
import Filters from '../../../../components/Filters';
import Search from '../../../../components/formControls/Search';
import PbxVirtualOperatorOfficeRow from './PbxVirtualOperatorOfficeRow';
import { fetchPbxQueuesRequest } from '../../../../js/phone/actions';
import {
  getFetchPbxQueuesError,
  getFetchPbxQueuesLoaded,
  getPbxEditingQueues,
} from '../../../../js/phone/selectors';
const messages = defineMessages({
  intro: {
    id: 'PbxVirtualOperatorOfficesList.intro',
    defaultMessage: 'If you need other numbers to link to offices, contact our assistance team.',
  },
  office: {
    id: 'PbxVirtualOperatorOfficesList.office',
    defaultMessage: 'Office',
  },
  enabled: {
    id: 'PbxVirtualOperatorOfficesList.enabled',
    defaultMessage: 'Enabled',
  },
  number: {
    id: 'PbxVirtualOperatorOfficesList.number',
    defaultMessage: 'Number',
  },
  pronunciation: {
    id: 'PbxVirtualOperatorOfficesList.pronunciation',
    defaultMessage: 'Additional pronunciation',
  },
  transfer: {
    id: 'PbxVirtualOperatorOfficesList.transfer',
    defaultMessage: 'Transfer profile',
  },
  festivities: {
    id: 'PbxVirtualOperatorOfficesList.festivities',
    defaultMessage: 'Festivities',
  },
  opening: {
    id: 'PbxVirtualOperatorOfficesList.opening',
    defaultMessage: 'Opening table',
  },
  searchPlaceHolder: {
    id: 'PbxVirtualOperatorOfficesList.searchPlaceHolder',
    defaultMessage: 'Filter offices by name',
  },
  noRow: {
    id: 'PbxVirtualOperatorOfficesList.noRow',
    defaultMessage: 'There are no offices',
  },
});

class PbxVirtualOperatorOfficesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
    };
  }

  componentDidMount() {
    this.props.fetchMessages({
      name: null,
    });
    this.props.fetch();
    this.props.fetchSettings();
  }

  handleFilter = (name) => {
    this.setState({ name });
  };

  render() {
    const {
      errorFetch,
      offices,
      loading,
      intl: { formatMessage },
    } = this.props;
    const filteredOffices = offices.filter((office) => {
      return (
        this.state.name === null ||
        (office.description && office.description.toLowerCase().includes(this.state.name.toLowerCase()))
      );
    });
    return (
      <>
        <div>
          <span style={{fontStyle: 'italic'}}>{formatMessage(messages.intro)}</span>
        </div>
        <Filters id={this.props.id}>
          <div className="row pt-2 pb-2">
            <div className="col">
              <Search
                id="filterNameOffice"
                name="filterNameOffice"
                placeholder={formatMessage(messages.searchPlaceHolder)}
                onChange={this.handleFilter}
                text={this.state.name}
              />
            </div>
          </div>
        </Filters>
        {errorFetch ? (
          <GlobalErrorPage />
        ) : loading ? (
          <Loading />
        ) : (
          <div className="rounded border p-2 mt-2">
            <table className="table table-borderless table-hover">
              <thead
                style={{
                  color: 'var(--yn-blue-darkest)',
                }}
              >
                <tr>
                  <th>{formatMessage(messages.enabled)}</th>
                  <th>{formatMessage(messages.number)}</th>
                  <th>{formatMessage(messages.office)}</th>
                  <th>{formatMessage(messages.pronunciation)}</th>
                  <th>{formatMessage(messages.transfer)}</th>
                  <th>{formatMessage(messages.festivities)}</th>
                  <th>{formatMessage(messages.opening)}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {filteredOffices.map((office) => (
                  <PbxVirtualOperatorOfficeRow key={office} office={office} />
                ))}
              </tbody>
              {(!filteredOffices || filteredOffices.length === 0) && (
                <tfoot>
                  <tr>
                    <td colSpan="7">{formatMessage(messages.noRow)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: !getFetchPbxQueuesLoaded(state),
    errorFetch: getFetchPbxQueuesError(state),
    offices: getPbxEditingQueues(state),
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    fetch: fetchPbxQueuesRequest,
    fetchMessages: fetchVirtualOperatorMessagesRequest,
    fetchSettings: fetchVirtualOperatorSettingsRequest,
  })(PbxVirtualOperatorOfficesList)
);
